import { UtilsService } from './../../../../shared/tools/UtilsService';
import { HttpParams } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of, Subscription } from "rxjs";
import { catchError, filter, map, switchMap } from "rxjs/operators";
import { ArcHospiDto } from "src/app/api/models";
import { ContractService, HospitalizationService, QuestionnaireService, SysParamService } from "src/app/api/services";
import { loadContract, loadContractFailure, loadContractSuccess, submitCardId, submitCardIdFailure, submitCardIdSuccess, submitCardId_S4, submitCardId_S4Failure, submitCardId_S4Success } from "src/app/kiosk/components/contract/state/contract.actions";
import { ArcHospiService } from "src/app/kiosk/services/arcHospi.service";
import { eKioskError } from "src/app/shared/models/api/constants";
import { AppState, getState } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import { identificationSuccess } from "../../archospi/state/archospi.actions";
import { setErrorMsg } from "../../error/state/error.actions";
import { setLangToShow } from "../../language/state/language.actions";
import { setCardIdShowPage, setContractHasLanguageSupported, setHasActiveQuestionnaire, setPrehospi, setSelectedLanguage, setStartupProcessDone } from "../../transaction-info/state/transaction-info.actions";

@Injectable()
export class ContractEffects implements OnDestroy {

	private state: AppState;
	private subs: Subscription[] = [];

	constructor(private actions$: Actions, private contractService: ContractService, private sysParamService: SysParamService, private store: Store<AppState>, private arcHospiService: ArcHospiService,
		private questionService: QuestionnaireService, private hospitalizationService: HospitalizationService,private utilsService: UtilsService) { 
			this.subs.push(getState(this.store).subscribe(state => this.state = state));
		}

	public loadContractInformations$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(loadContract),
			switchMap(({
				InsurerId,
				CardNumber,
				SiteId,
				Language,
				InsurerQuestionnaireId,
			}) =>
				this.contractService.contractGetCurrent({InsurerId,CardId: CardNumber,}).pipe(
					map((selectedContract) => {
						if (selectedContract == null) {
							throw new Error();
						}

						return selectedContract;
					}),
					switchMap((selectedContract) => {
						return this.hospitalizationService.hospitalizationCheckExistingPreHospi({ siteId: SiteId }).pipe(
							map((prehospi) => {
								// return {x:validateCardIdReturn, y: prehospi }
								const validateCardId = InsurerId;
								//debugger;
								let msgToDisplay: string;
								let kioskError: eKioskError;
								const insurer = this.state.transactionInfo.selectedInsurer;
								let noTranslate = false;
								let blockProcess = false;
								let continueValidations = true;
								if (validateCardId == null) {
									if (this.state.transactionInfo.cardIdInUrl) {
										blockProcess = true;
										kioskError = eKioskError.CONTRACT_NOT_KNOWN;
									}
									else {
										blockProcess = false;
									}
									continueValidations = false;
								}

								if ((environment.kioskMode && !insurer.kioskChannelAllowed) || (!environment.kioskMode && !insurer.homeChannelAllowed)) {
									if (environment.kioskMode)
										kioskError = eKioskError.INSURER_KIOSK_NOT_ALLOWED;
									else
										kioskError = eKioskError.INSURER_HOME_NOT_ALLOWED;

									blockProcess = true;
									continueValidations = false;
									if (insurer.questionnaireDeclarationsAllowed) {
										if (insurer.s1messageIdKioskForbiddenNavigation != null) {
											msgToDisplay = insurer.s1messageIdKioskForbiddenNavigation["text" + Language.languageCode];
											noTranslate = true;
										}
									}
									else if (insurer.callCenterDeclarationsAllowed) {

										if (prehospi?.hospitalizationId != null) {
											blockProcess = false;
											this.store.dispatch(setPrehospi({ data: prehospi }));
										}
										if (insurer.s5MessageIdContinueNavigation != null) {
											msgToDisplay = insurer.s5MessageIdContinueNavigation["text" + Language.languageCode];
											noTranslate = true;
										}
									}
								}
								if (blockProcess) {
									if (msgToDisplay == null)
										msgToDisplay = eKioskError[kioskError];

									this.store.dispatch(setErrorMsg({ data: msgToDisplay, noTranslation: noTranslate, KioskError: kioskError }));
								}

								return { selectedContract, continueValidations };
							})
						);
					}),
					switchMap(({selectedContract, continueValidations }) => {
						if (continueValidations)
							return this.questionService.questionnaireCheckActiveQuestionnaire$Json({ InsurerQuestionnaireId: InsurerQuestionnaireId }).pipe(
								map((questionnaire) => {
									if (!questionnaire.isOk) {
										this.store.dispatch(setHasActiveQuestionnaire({ data: false }));
										throw new Error(questionnaire.errorMessage);
									}
									this.store.dispatch(setHasActiveQuestionnaire({ data: true }));
									return { selectedContract, continueValidations: true };
								})
							)
						return of({selectedContract, continueValidations});
					}),
					switchMap(({ selectedContract, continueValidations }) => {
						if (continueValidations)
							return this.contractService.contractCheckLanguageIsSupported({ languageSelected: Language.languageCode }).pipe(
								map((data) => {
									this.store.dispatch(setStartupProcessDone({ data: true }));
									
									if (!data.isOk) {
										this.store.dispatch(setLangToShow({ data: data.languageSupported.split(",") }));
										this.store.dispatch(setSelectedLanguage({ data: undefined }));
										
										return loadContractSuccess({ data: selectedContract });
									} else {
										this.store.dispatch(setContractHasLanguageSupported({ data }));
										this.store.dispatch(setCardIdShowPage({ data: false }));
										
										return loadContractSuccess({ data: selectedContract });
									}
								}));
						else
							throw new Error("");
					}),
					catchError((err) =>of(loadContractFailure({ error: err })))
				)
			)
		);
	});
	public submitCardId_S4$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(submitCardId_S4),
			filter( ({ cardNumber, insurer, siteId, hospitalNo, language, urls4 }) => this.utilsService.validateInsurerForKioskHomeProcess(insurer,language)),
			switchMap(({ cardNumber, insurer, siteId, hospitalNo, language, urls4 }) =>
				this.arcHospiService.identification(cardNumber, insurer.insurerId, siteId, hospitalNo, language).pipe(
					map((arcHospi) => {
						if (arcHospi == null) {
							throw new Error("");
						}
						this.store.dispatch(identificationSuccess({ data: arcHospi }));

						this.redirectToS4(urls4, cardNumber, insurer.insurerId, arcHospi, language.languageCode);
						return submitCardId_S4Success();
					}),
					catchError((err) => {
						return of(submitCardId_S4Failure({ error: err }));
					})
				)
			)
		);
	});
	public submitCardId$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(submitCardId),
			filter(({ cardNumber, insurer, siteId, hospitalNo, language}) => this.utilsService.validateInsurerForKioskHomeProcess(insurer,language)),
			switchMap(({ cardNumber, insurer, siteId, hospitalNo, language}) =>
				this.arcHospiService.identification(cardNumber, insurer.insurerId, siteId, hospitalNo, language).pipe(
					map((arcHospi) => {
						if (arcHospi == null) throw new Error();
						this.store.dispatch(identificationSuccess({ data: arcHospi }));
						this.store.dispatch(setStartupProcessDone({ data: true }));
						this.store.dispatch(setCardIdShowPage({ data: false }));
						return submitCardIdSuccess({ cardid: cardNumber }); // Return success with cardId
					}),
					catchError((error) => {
						this.store.dispatch(setErrorMsg({ data: error.message || "An error occurred", noTranslation: false }));
						return of(submitCardIdFailure({ error }));
					})
				)
			)
		);
	});

	private redirectToS4(urls4: string, cardId: string, insurerId: string, archospi: ArcHospiDto, languageCode: string) {
			let params = new HttpParams();
			params = params.append("url", urls4);
			
			let url = "./assets/service4/Service4Frameset.html?";

			if (!environment.kioskMode) {
				params = params.append("cardnumber", cardId);
				params = params.append("insurerid", insurerId);
				params = params.append("transacId", archospi.transactionId);
				params = params.append("lang", languageCode);
				if (this.state.kiosk.homeS4AddChecksum) params = params.append("chk", this.computeCheckSum(archospi.transactionId));

				url += params.toString();
			} else {
				params = params.append("cardnumber", cardId);
				params = params.append("insurerid", insurerId);
				params = params.append("transacId", archospi.transactionId);
				params = params.append("currenthospital", this.state.transactionInfo.defaultHospitalNo?.toString());
				params = params.append("currentsite", this.state.transactionInfo.defaultSiteId?.toString());

				url += params.toString();
			}
			window.location.href = url;
	}

	private computeCheckSum(HexadecimalString: string): string {
		let iCheckSum = 0;
		let hexVal;
		HexadecimalString = HexadecimalString.replace("-", "");

		//Group each two bits together...
		for (let x = 0; x < HexadecimalString.length - 1; x = x + 2) {
			hexVal = HexadecimalString[x].toString() + HexadecimalString[x + 1].toString();
			//Add these to overall count
			iCheckSum += parseInt(hexVal, 16);
		}

		//Count mod 0x100 or 256(int)
		iCheckSum = iCheckSum % 256;

		//Return 256 - count
		hexVal = (256 - iCheckSum).toString(16).toUpperCase();

		return hexVal;
	}
	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}
}

